export default "__VITE_ASSET__Dx7wkuG9__"